import { CloudinarySettings } from '@material-bank/mb-uikit/context';

export type Env = 'local' | 'stage2' | 'uat2' | 'uatEu' | 'prod' | 'prodEu';
export type EnvRegion = 'US' | 'EU';

const getEnv = (): Env => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === 'materialbank.test') {
    return 'local';
  } else if (hostname.includes('stage2')) {
    return 'stage2';
  } else if (hostname.includes('uat') && hostname.includes('eu')) {
    return 'uatEu';
  } else if (hostname.includes('uat2')) {
    return 'uat2';
  } else if (hostname.includes('materialbank.eu')) {
    return 'prodEu';
  } else {
    return 'prod';
  }
};

export const ENV = getEnv();

export function envRegionSelect<T>(
  specifics: Partial<Record<EnvRegion, T>> & { default: T },
): T;
export function envRegionSelect<T>(
  specifics: Record<EnvRegion, T> & { default?: T },
): T;
export function envRegionSelect<T>(
  specifics: Partial<Record<EnvRegion, T>> & { default?: T },
): T | undefined;
export function envRegionSelect<T>(
  specifics: Partial<Record<EnvRegion, T>> & { default?: T },
) {
  return specifics[ENVIRONMENT_REGION] ?? specifics.default;
}

export const CLOUDINARY_SETTINGS: CloudinarySettings = {
  baseUrl: '',
  s3Url: '',
  s3BlogUrl: '',
};
